import { useState } from "react";
import { Button } from "../ui/button";
import { HiOutlineBookOpen } from "react-icons/hi";
import { Dialog, Table, useDisclosure, } from '@chakra-ui/react';
import { DialogBody, DialogContent, DialogFooter, DialogRoot, DialogTitle, DialogTrigger } from "../ui/dialog";

interface newUserProps {
    ReadRecipts: ReadRecipts[]
}

interface ReadRecipts {
    id: string,
    announcement_id: string,
    user_id: string,
    user_name: string,
    timestamp: string,
}

export default function AnnouncementReadRecipts(props: newUserProps) {
    const { onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState<boolean>(false);

    const handleClickOpen = () => {
        onOpen();
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    function toNiceDate(iso: string){
        const date = new Date(iso)

        const formatted = date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });

        return formatted
    }

    return (
        <>
            <DialogRoot
                open={open}
                aria-describedby="alert-dialog-slide-description"
                size={{ base: "md", lg: "full"}}
            >
                <Dialog.Backdrop />
                <DialogTrigger>
                    <Button bg={"AbleBlue"} color={"white"} size={"sm"} marginLeft={{ base: "10px", lg: "30px" }}
                        _hover={{ bg: "AbleYellow", color: "white" }}
                        _active={{ bg: "#ECB500" }}
                        onClick={handleClickOpen}
                    >
                        <><HiOutlineBookOpen />{"Read Receipts"}</>
                    </Button>
                </DialogTrigger>
                <DialogContent marginTop={"0px"} marginBottom={"0px"}>
                    <DialogTitle>Read Recipts</DialogTitle>
                    <DialogBody padding={"10px"}>
                        <Table.Root>
                            <Table.Header>
                                <Table.Row>
                                    <Table.ColumnHeader>Name</Table.ColumnHeader>
                                    <Table.ColumnHeader>Time</Table.ColumnHeader>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {props.ReadRecipts.map((item) => (
                                    <Table.Row key={item.id}>
                                        <Table.Cell>{item.user_name}</Table.Cell>
                                        <Table.Cell>{item.timestamp ? toNiceDate(item.timestamp) : "N/A"}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table.Root>
                    </DialogBody>
                    <DialogFooter>
                        <DialogTrigger>
                            <Button onClick={handleClose} colorScheme="red" marginLeft={"10px"}>Cancel</Button>
                        </DialogTrigger>
                    </DialogFooter>
                </DialogContent>
            </DialogRoot>
        </>
    );
}